'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getSupplierReturns(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `supplier-returns${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getSupplierReturn(id) {
    const data = {
      method: 'get',
      url: 'supplier-return/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createSupplierReturn(json) {
    const data = {
      method: 'post',
      url: 'supplier-return',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Supplier return created successfully', 2000)
      return response.data;
    }
  },
  async updateSupplierReturn(json, id) {
    const data = {
      method: 'put',
      url: 'supplier-return/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier return updated successfully', 2000)
      return true;
    }
  },
  async deleteSupplierReturn(id) {
    const data = {
      method: 'delete',
      url: 'supplier-return/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier return deleted successfully', 2000)
      return true;
    }
  },
  async approveSupplierReturn(id) {
    const data = {
      method: 'patch',
      url: 'supplier-return-approve/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier return approved successfully')
      return true;
    }
  },
  async getSupplierReturnNextNo() {
    const data = {
      method: 'get',
      url: 'supplier-returnNextNo',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getSupplierReturnDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `supplier-return/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createSupplierReturnDetails(json) {
    const data = {
      method: 'post',
      url: 'supplier-return-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Product added to return', 2000)
      return true;
    }
  },
  async updateSupplierReturnDetails(json, id) {
    const data = {
      method: 'put',
      url: 'supplier-return-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Return product updated', 2000)
      return true;
    }
  },
  async deleteSupplierReturnDetails(id) {
    const data = {
      method: 'delete',
      url: 'supplier-return-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Return product deleted', 2000)
      return true;
    }
  },
}
